import React from 'react'
import {commonStyleObj} from '../utils/utils'

const countReducer = (currCount, step) => {
    return currCount + step
}

const initialCount = 0
const step = 3

const CounterComponent = () => {
    const [count, changeCount] = React.useReducer(countReducer, initialCount)
    const increment = () => changeCount(step)

    return (
    <div style={commonStyleObj}>
      <h3>Counter Reducer Example</h3>
      <h5>Counter Value: {count}</h5>
      <h5>Step Value: {step}</h5>
      <button onClick={increment}>increment</button>
    </div>
  )
}

export default CounterComponent